import React, { useCallback, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { flexRender } from '@tanstack/react-table'

import urls from '../../../../utils/constants/urls'
import Spinner from '../../Spinner'
import { AppStateContext } from '../../../features/explorer/AppStateContext'

const TableBody = ({ page, rows, loading, isClickable = true }) => {
    const data = page || rows || []
    const { mapState: { selectedFeatures, allFeatures, map }, setMapState } = useContext(AppStateContext)
    const selectedRecords = selectedFeatures.map(feature => feature.get('FacilityID'))
    const location = useLocation()

    const onClick = useCallback((row, isHighlighted) => {
        let newFeatures = selectedFeatures
        if (isHighlighted) {
            newFeatures = selectedFeatures.filter(x => x.get('FacilityID') !== row.original.FacilityID)
        } else {
            const newFeature = allFeatures.find(x => x.get('FacilityID') === row.original.FacilityID)
            if (newFeature) {
                newFeatures = [...selectedFeatures, newFeature ]
                const featurePoint = newFeature.getGeometry()
                map.getView().fit(featurePoint, {padding: [170, 50, 30, 150], minResolution: 50})
            }
        }
        setMapState(prevMapState => ({
            ...prevMapState,
            selectedFeatures: newFeatures ? newFeatures : prevMapState.selectedFeatures
        }))
    }, [selectedFeatures])

    return (
        <tbody>
            {loading ? (
                <tr>
                    <td colSpan="100%">
                        <Spinner />
                    </td>
                </tr>
            ) : (
                data.map((row) => {
                    const isHighlighted = isClickable && selectedRecords.includes(
                        row.original.FacilityID
                    )
                    return (
                        <tr
                            key={row.id}
                            onClick={() => {
                                if (isClickable && location.pathname === urls.home) {
                                    onClick(row, isHighlighted)
                                }
                            }}
                            className={isHighlighted ? 'is-selected highlightedRow' : ''}
                        >
                            {row.getVisibleCells().map(cell => {
                                return (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}

export default TableBody
